<template>
  <div @click="handleFullPageClick">
    <div class="header">
      <div class="logo" style="padding: 20px 14px;">
        <img v-if="showImgLogo && pcLogo" v-bind:src="pcLogo" alt="" @error="handleLogoError">
        <p style="font-size:16px;" v-else>{{ textLogo }}</p>
      </div>
      <div class="header-middle">
        <top-tabs ref="topTabs"></top-tabs>
      </div>
      <top-user ></top-user>
    </div>
    <left-menu></left-menu>
    <div :style="{left: (showLeftMenu ? 251 : 0) + 'px'}" class="main">
      <keep-alive :include="cachedViews" >
        <router-view v-show="!iframeState" ></router-view>
      </keep-alive>
      <common-iframe
        v-show="iframeState"
        :showBackBotton="showBackBotton"
        :showTopOperation="showTopOperation"
        :bindRouteUrl="iframeBindRouteUrl"
        iframeName="mainContent" >
      </common-iframe>
      <el-tooltip class="item" effect="dark" :content="(showLeftMenu ? '隐藏' : '显示') + '侧边栏'" placement="top">
        <div @click="handleShowLeftMenu" class="singleBtn tree-trigger">
          <i :class="{'icon-sideunfold': !showLeftMenu}" class="mng icon-sidefold"></i>
        </div>
      </el-tooltip>
    </div>
  </div>
</template>
<script>
  import LeftMenu from '../components/left-menu/left-menu.vue'
  import TopTabs from '../components/top-tabs/top-tabs.vue'
  import TopUser from '../components/top-user/top-user.vue'
  import CommonIframe from '../components/iframe/iframe.vue'
  import util from '../libs/util'
  import {STORE_APP_MUTATION_TYPES} from '../libs/constants'
  import ws from '../websocket'

  export default {
    components: {
      LeftMenu,
      TopTabs,
      TopUser,
      CommonIframe
    },
    data() {
      return {
        showBackBotton: true,
        showTopOperation: true,
        iframeBindRouteUrl: false,
        showImgLogo: true
      }
    },
    computed: {
      cachedViews() {
        return this.$store.state.app.cachedViews
      },
      iframeState: function () {
        return this.$store.state.app.showIframe
      },
      showLeftMenu: function () {
        return this.$store.state.app.showLeftMenu
      },
      pcLogo: function() {
        const peWebSiteDetail = this.$store.state.app.peWebSiteDetail
        if (peWebSiteDetail && peWebSiteDetail.pcLogo) {
          return util.baseUrl + '/' + peWebSiteDetail.pcLogo
        }
        return ''
      },
      textLogo() {
        const peWebSiteDetail = this.$store.state.app.peWebSiteDetail
        return peWebSiteDetail.title || '管理平台'
      }
    },
    mounted() {
      if (util.enableWebSocket) {
        // 初始化webSocket
        ws.init()
      }
    },
    methods: {
      handleFullPageClick() { // 全页面点击事件
        this.$refs.topTabs.closeTopTabDropMenu()
      },
      // 切换左侧菜单显示/隐藏
      handleShowLeftMenu() {
        this.$store.commit(STORE_APP_MUTATION_TYPES.SET_SHOW_LEFT_MENU, !this.showLeftMenu)
      },
      handleLogoError() {
        this.showImgLogo = false
      }
    }
  }
</script>
<style lang="scss">
  .header {
    .logo {
      p {
        font-size: 22px;
        font-weight: bold;
        color: #fff;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/manager/manager_index.vue